<template>
  <router-view/>
</template>


<script>


export default {
  name: 'App',
  data() {
    return {}
  },
  mounted() {
    document.title = "ADMIA";
  }
}
</script>

<style scoped>

</style>
